import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "IntelliWarrior";

function titleForPath(pathname: string): string {
  const entries: [RegExp, string][] = [
    [/^\/$/, `${BASE} — AI-Powered Credit Repair`],
    [/^\/pricing$/, `Pricing — ${BASE}`],
    [/^\/features$/, `Features — ${BASE}`],
    [/^\/terms$/, `Terms of Service — ${BASE}`],
    [/^\/privacy$/, `Privacy Policy — ${BASE}`],
    [/^\/login$/, `Login — ${BASE}`],
    [/^\/dashboard$/, `Dashboard — ${BASE}`],
    [/^\/clients\/add$/, `Add client — ${BASE}`],
    [/^\/clients\/[^/]+$/, `Client — ${BASE}`],
    [/^\/clients$/, `Clients — ${BASE}`],
    [/^\/disputes$/, `Disputes — ${BASE}`],
    [/^\/dispute-letters$/, `Dispute letters — ${BASE}`],
    [/^\/ai-analysis$/, `AI analysis — ${BASE}`],
    [/^\/billing$/, `Billing — ${BASE}`],
    [/^\/compliance$/, `Compliance — ${BASE}`],
    [/^\/reports$/, `Reports — ${BASE}`],
    [/^\/score-tracker$/, `Score tracker — ${BASE}`],
    [/^\/tasks$/, `Tasks — ${BASE}`],
    [/^\/settings$/, `Settings — ${BASE}`],
    [/^\/staff$/, `Staff — ${BASE}`],
    [/^\/affiliates$/, `Affiliates — ${BASE}`],
    [/^\/automations$/, `Automations — ${BASE}`],
    [/^\/import$/, `Import — ${BASE}`],
    [/^\/portal\/login$/, `Client portal login — ${BASE}`],
    [/^\/portal\/dashboard$/, `Client portal — ${BASE}`],
    [/^\/portal\/disputes$/, `My disputes — ${BASE}`],
  ];

  const hit = entries.find(([re]) => re.test(pathname));
  if (hit) {
    return hit[1];
  }
  return `Page not found — ${BASE}`;
}

const DocumentTitle: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = titleForPath(pathname);
  }, [pathname]);

  return null;
};

export default DocumentTitle;
